(() => {
  if (customElements.get('kj-collection-shimmer')) return;
  customElements.define('kj-collection-shimmer', class extends HTMLElement {
    connectedCallback() {
      if (this.life) return;
      this.life = new AbortController();
      const options = { signal: this.life.signal };
      document.addEventListener('click', event => {
        if (document.querySelector('kj-collection-shimmer') !== this) return;
        const link = event.target.closest?.('a[href]');
        if (!link?.closest('[data-kj-navigation-loading]') || event.button !== 0 ||
            event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
            link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || !url.pathname.includes('/collections/') ||
            (url.pathname === location.pathname && url.search === location.search)) return;
        queueMicrotask(() => {
          if (!event.defaultPrevented && this.isConnected) this.show(link);
        });
      }, options);
      window.addEventListener('pageshow', () => this.reset(), options);
      window.addEventListener('pagehide', () => this.reset(), options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.reset();
      }, options);
    }
    show(link) {
      this.reset();
      const grid = document.querySelector('.kc-grid #product-grid');
      const cards = grid ? [...grid.querySelectorAll(':scope > .grid__item')] : [];
      if (!cards.length) return;
      this.grid = grid;
      this.cards = cards;
      this.previousBusy = this.grid.getAttribute('aria-busy');
      this.previousInert = this.grid.inert;
      // Read geometry together before writing styles, avoiding repeated layout work.
      const heights = cards.map(card => {
        const media = card.querySelector('.card__inner');
        return media?.getBoundingClientRect().height || card.clientWidth;
      });
      cards.forEach((card, index) => card.style.setProperty('--kc-skeleton-image', `${heights[index]}px`));
      this.grid.setAttribute('aria-busy', 'true');
      this.grid.inert = true;
      this.grid.classList.add('kc-shimmer');
      link.classList.add('is-pending');
      this.link = link;
      this.textContent = 'Loading collection. Please wait.';
      // A cancelled native navigation must not leave the products unavailable.
      this.expiry = setTimeout(() => this.reset(), 20000);
    }
    reset() {
      clearTimeout(this.expiry);
      this.link?.classList.remove('is-pending');
      this.link = null;
      if (this.grid) {
        this.grid.classList.remove('kc-shimmer');
        if (this.previousBusy === null) this.grid.removeAttribute('aria-busy');
        else this.grid.setAttribute('aria-busy', this.previousBusy);
        this.grid.inert = this.previousInert;
        this.cards.forEach(card => card.style.removeProperty('--kc-skeleton-image'));
        this.cards = null;
        this.grid = null;
      }
      this.textContent = '';
    }
    disconnectedCallback() { this.reset(); this.life?.abort(); this.life = null; }
  });
})();
